import { AlertCircle, AlertTriangle, CheckCircle } from 'lucide-react';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { AggregatedPaymentStatus } from '@/features/dashboard/financialTransactions/types/AggregatedPaymentStatus.ts';

export const aggregatedPaymentStatusTableConfig: EnumTableConfig = {
  [AggregatedPaymentStatus.OK]: toneEnumConfig('OK', 'success', CheckCircle),
  [AggregatedPaymentStatus.OVERPAYMENT]: toneEnumConfig(
    'Nadpłata',
    'warning',
    AlertTriangle,
  ),
  [AggregatedPaymentStatus.OVERDUE_PAYMENT]: toneEnumConfig(
    'Zaległa płatność',
    'error',
    AlertCircle,
  ),
};
